module.exports = __webpack_public_path__ + "static/media/letter_y.e847b0e3.m4a";